import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { FloorScreed } from 'landings';
import { RemoteProps } from './widgets-types';

export const FloorScreedRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <FloorScreed />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
